import { SalaryPerDate } from "../../employment/employmentApi";
import { SalaryIncreaseStatus } from "./common";

interface SalaryBase {
  version: number;
  afterRaiseSalaryPerDate: SalaryPerDate[];
  raiseDateSalary: SalaryPerDate;
  hrRepresentative: string; // id
  firstName: string; // talent first name
  lastName: string; // talent first name
  status: SalaryIncreaseStatus;
  raiseDateContEmpExists: boolean;
  talentId: string;
  workTitleId: string;
}

export interface ShiftSalary extends SalaryBase {

}

export interface EmploymentSalary extends SalaryBase {
  employmentId: string;
  employerName: string;
}

export type ShiftSalaryData = { data: SalaryRow[]; cursor: string | null };
export type SalaryRow = ShiftSalary | EmploymentSalary;

export type SalaryRows = SalaryRow[] | ShiftSalaryData;

export type MassUpdateStatusRowId = string;

export enum MassUpdateRowClarity {
  NORMAL = "NORMAL",
  UNCLEAR = "UNCLEAR",
};

export interface MassUpdateStatus {
  massUpdateId: string;
  unclearRows: MassUpdateStatusRowId[];
}

export interface MassUpdateStatusQuery {
  massUpdateId: string;
  mock?: string;
}

export interface MassUpdateClarityPayload {
  massUpdateId: string;
  rowClarities: Record<MassUpdateStatusRowId, MassUpdateRowClarity>
}

export interface BulkSalaryIncreaseQuery {
  isIncreaseApplied: string; // boolean
  hasContEmp?: string; // boolean
  baseEqualsGroup?: string; // boolean
  target: string;
  tesId: string;
  /** Present when target is TES_TABLES (reserved for future bulk table projection API). */
  tesSalaryTableSourceId?: string;
  tesSalaryTableTargetId?: string;
  tesSalaryTableId?: string;
  tesSelectionAtOrAfterRaise?: string; // boolean
  tesSelectionModes?: string; // comma separated TesSalaryTableSelectionMode
  salaryStartDate?: string;
  salaryType?: string; // TODO: use SalaryType enum
  raiseDate: string;
  salaryEndDate?: string;
  workTimeType?: string; // comma separated WorkTimeType
  workTitleIds?: string; // comma separated work title ids
  cursor?: string;
  pageSize?: string; // number
  mock?: string;
  isUnclear?: string; // boolean
  // current salaries
  [key: `salaryFrom_${string}`]: string;
  [key: `salaryTo_${string}`]: string;
}

export interface Kta {
  hrRepresentative: string; // id
  firstName: string; // talent first name
  lastName: string; // talent first name
  status: SalaryIncreaseStatus;
  talentId: string;
  employmentId: string;
  contEmpId: string;
  employerName: string;
  startDate: string;
  endDate?: string;
}
